module.exports = __webpack_public_path__ + "static/media/linkedin.2f4463ee.svg";